module.exports = __webpack_public_path__ + "static/media/quasim_shaikh.c9fe10c8.png";